export default {
      id: "truck-body-usage",
      viewBox: "0 0 381 229",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#truck-body",
      toString: function () {
        return this.url;
      }
    }